// French content for smartQ marketing site
import { SiteContent, EtapeItem } from './content'

export const contentFr: SiteContent = {
  pages: {
    home: {
      title: "Accueil / Aperçu",
      purpose: "Expliquer en un coup d'œil pourquoi smartQ compte pour une petite entreprise : moins d'attente visible, des clients plus sereins et un service plus fluide grâce à une Virtual queue.",
      hero: {
        headline: "La file sur votre mobile, ne perdez plus votre temps à attendre !",
        sub: "Libérez-vous de la gestion de l’attente et captez davantage de clients… ravis de revenir ! 😊<br><br>**Mise en place simple · Pilotage simple · Aucun engagement de durée**",
        ctaPrimary: "Essayez gratuitement",
        ctaSecondary: "Réserver une démo"
      },
      benefits: [
        "**Plus de ventes**",
        "**Meilleure gestion des pics d'affluence**",
        "**Fidéliser clients**",
        "**Améliorer l'expérience client**",
        "**Réduire le temps d'attente**",
        "**Réduire la file visible**.",
        "**Fluidifier le service**",
        "**Efficience des ressources**",
        "**Lisser l'affluence vers les périodes creuses**",
        "**Rester en contact avec vos clients**",
        "**Mise en place simple**",
        "**Personnalisable**",
        "**Peu coûteux**",
        "**Compatible avec votre gestion actuelle**"
      ],
      steps: [
        "Le client prend un ticket sur son téléphone en 5 secondes.",
        "Le client suit sa position sur son téléphone et est notifié quand son tour approche.",
        "Le client est notifié quand son tour est arrivé avec l'endroit et la personne qui le reçoit."
      ],
      video: {
        title: "Comment ça marche",
        description: "Découvrez comment fonctionne smartQ en action",
        videoId: "80c038d9d3f14df78d2df0260d1f4898"
      },
      comparison: [
        { aspect: "Rejoindre", physical: "Faire la queue / ticket papier", virtual: "Scanner QR / site web / ajout par l'employé" },
        { aspect: "Mises à jour", physical: "Demander au personnel / regarder écrans", virtual: "sur téléphone/notifications push en temps réel" },
        { aspect: "Attente", physical: "Paraît longue et incertaine", virtual: "Transparente et perception réduite" },
        { aspect: "Absences", physical: "Plus fréquentes, difficiles à gérer", virtual: "Annulation et reports faciles" },
        { aspect: "Opérations", physical: "Arrivées imprévisibles", virtual: "Arrivées prévues et connues à l'avance" },
        { aspect: "Image de marque", physical: "Ticket générique", virtual: "Ticket avec votre branding" }
      ],
      useCases: [
        "Commerces (SAV)",
        "Coiffeurs/Salons de beauté",
        "Santé",
        "Restaurants/Foodtrucks",
        "Guichets",
        "Ateliers/Réparations",
        "Salons/Evénements",
        "Accueil"
      ],
      indispensable: [
        {
          title: "Pics d'affluence ponctuels",
          description: "Lissez le flux vers les périodes creuses, éliminez les bouchons et gardez un rythme de service régulier."
        },
        {
          title: "Abandons et No-show",
          description: "Diminuez les abandons, l'attente virtuelle est mieux acceptée. Proposez le report ou l'annulation."
        },
        {
          title: "Parcours omnicanal (sans RDV + RDV + en ligne)",
          description: "Unifiez l'ordre de passage et synchronisez tous les canaux d'entrée."
        },
        {
          title: "Durées de service variables",
          description: "Réduisez les temps morts entre interventions courtes et longues."
        },
        {
          title: "Espace d'accueil limité",
          description: "Déportez l'attente hors site pour plus de confort et de sécurité."
        },
        {
          title: "Multiples files et priorités (tri, urgences, VIP)",
          description: "Orchestrez l'ordre de passage"
        },
        {
          title: "Ressources d'équipe fluctuantes",
          description: "Alignez le débit de prise en charge avec la présence réelle et les aléas du planning."
        },
        {
          title: "Pilotage par la donnée",
          description: "Ajustez vos ressources à la demande par service en temps réel"
        },
        {
          title: "Événements et lancements à forte incertitude",
          description: "Absorbez les vagues de demande sans chaos opérationnel."
        },
        {
          title: "Expérience client irréprochable",
          description: "Vous valorisez réellement leur temps : l'attente est mieux perçue, plus sereine. La satisfaction et la confiance augmentent, tout comme la préférence de marque et la rétention."
        }
      ],
      proof: [
        "Augmentation de la satisfaction et la conversion avec disminution des abandons.",
        "Des insights en temps réel pour optimiser équipes et flux.",
        "Réduction des délais réels et perçus."
      ],
      objections: [
        { claim: "Ça va compliquer notre activité.", reply: "Très simple à utiliser au quotidien, il y a juste à faire \"Appel Suivant\" sur son téléphone." },
        { claim: "Mes clients ne veulent pas d'appli.", reply: "Il ne s'agit pas d'une application mais d'un simple QR code à scanner.\nCe que vos clients ne veulent surtout pas est perdre leur temps.\nAutrement, c'est compatible avec votre queue actuelle simultanément." },
        { claim: "Est-ce compatible avec mon système de gestion actuel (rendez-vous, queue physique) simultanément?", reply: "Tout à fait. Vos clients récupèrent leur un numéro (oral/papier/numérique). Si vous avez déjà un système par prise de rendez-vous, vos clients seront informé de l'heure exacte de prise en charge." },
        { claim: "Mon business est trop petit.", reply: "Idéal pour toute taille d'entreprise." }
      ],
      compliance: [
        "Informer clairement sur l'usage des données, recueillir le consentement (SMS/e‑mail), proposer une alternative papier pour l'équité d'accès."
      ],
      implementation: [
        "Affichez un QR à l'entrée, gérez depuis un tableau de bord web/mobile, option d'écran (TV/tablette/téléphone) pour afficher qui est le prochain ."
      ],
      internalLinks: ["benefits", "features", "pricing"],
      visuals: [
        "Héros : client avec ticket digital sur smartphone.",
        "Schéma : file physique vs Virtual queue (flux comparé)."
      ],
      seo: { meta: "SmartQ transforme votre queue en **attente virtuelle** : entrée par QR code, lien web ou SMS, suivi **en temps réel**, **notification** quand c'est son tour. Installation simple, utilisation simple, **pas besoin de matériel**. **Essayez gratuitement**" }
    },

    features: {
      title: "Produit : smartQ — Fonctionnalités",
      purpose: "Montrer des outils concrets, faciles, utiles dès le jour 1 — sans jargon.",
      hero: {
        headline: "Votre téléphone attend à votre place",
        sub: "Fini les attentes inutiles. **Complet et très facile** à utiliser.",
        ctaPrimary: "Essayez gratuitement",
        ctaSecondary: "Réserver une démo"
      },
      benefits: [
        // Nouvel ordre demandé
        "Queue en temps réel. Suivi de la progression à distance en temps réel avec mise à jour de la position et du temps d'attente estimé.",
        "Notifications push. Notifications automatiques pour alerter quand son tour approche pour s'assurer qu'ils restent informés et engagés (Android).",
        "Accès multi-canal. Récupération de sa position par qr code, lien, e-mail, SMS, partage, notification push ou papier",
        "Alertes. Affichage d'avertissement en cas d'incident",
        "Appels numéro. Appel par message visuel, sonore et notification push sur téléphone (Android)",
        "Segmentation par service. Segmentez les clients dans différentes files selon le type de service proposé.",
        "Ouverture/Fermeture. Ouverture et Fermeture des queues. Gérez facilement les horaires d'ouverture et de fermeture de vos files d'attente selon vos besoins opérationnels.",
        "Envoi position. Option d'intégrer la queue avant d'arriver.",
        "Report ou Annulation. Possibilité de reporter ou annuler si votre passage n'est pas imminent.",
        "Affichage multi-écran. Affichage de l'avancement de la queue avec avertissement sonore sur tv, tablette ou téléphone.",
        "Branding. Nom, informations et logo à votre marque voire e-mail et SMS.",
        "Statistiques. Suivre et analyser les données de file d'attente, surveiller les temps d'attente et identifier les goulets d'étranglement afin d'optimiser leurs opérations et d'améliorer l'efficacité.",
        "Données Client. Récupération des données client pour rester en contact",
        "Configuration. Paramétrage permettant d'adapter le système de gestion des queues à des besoins spécifiques.",
        "Admin web & mobile. Gestion et paramétrage des queues à partir d'une interface utilisateur intuitive accessible web et mobile",
        "Multilangue. Disponible en Français, Anglais, Espagnol et Italian. Possibilité de rajouter d'autres langues."
      ],
      steps: [
        {
          title: "Étape 1 - Ouverture",
          subtitle: "Ouverture de la queue, permettre la prise de tickets (sur place ou à distance)",
          content: ""
        },
        {
          title: "Étape 2 - Appel suivant",
          subtitle: "Appel au client suivant. Possibilité de signaler la durée de traitement estimée.",
          content: ""
        },
        {
          title: "Étape 3 - Fermeture",
          subtitle: "Fermeture de la queue, plus possible de prendre des tickets",
          content: ""
        }
      ],
      useCases: [
        "Rejoindre à l'avance à distance.",
        "Envoyez par mail leur position à vos clients",
        "Prévenir vos clients, avec ou sans rendez-vous, de leur temps de passage réel. Notamment, en cas de retard.",
        "Avertissement en cas d'incidence",
        "Écran pour afficher le numéro appelé sur tv, tablette, téléphone ou ordinateur",
        "Report ou Annulation si l'attente est encore longue"
      ],
      proof: [
        "Des notifications préviennent à l'avance de l'approche de son tour.",
        "Excellence opérationnelle",
        "Heures de pointe sans stress"
      ],
      objections: [
        { claim: "Est-ce qu'ils vont pouvoir annuler?", reply: "Vous pouvez activer l'option d'annuler si l'attente est encore longue" },
        { claim: "Et notre marque ?", reply: "Vous pouvez personnalisé le logo et les fonctionnalités à votre marque" },
        { claim: "Et en cas de problème ?", reply: "Support disponible par mail et téléphone en cas de besoin" }
      ],
      compliance: [
        "Alternative ticket papier pour ceux qui ne partagent pas leurs coordonnées ; opt‑out facile."
      ],
      implementation: [
        "Installer, créer des queues, afficher le QR, commencer à servir — le tout depuis un admin simple (mobile & web)."
      ],
      internalLinks: ["journey", "implementation"],
      visuals: [
        "Maquette mobile (ticket + statut live), cartes du dashboard, exemples de notifications."
      ],
      seo: { meta: "Système de Gestion de Files d'Attente Simple et Facile : mises à jour, notifications, statistiques, personnalisation de marque et administration intuitive." }
    },

    benefits: {
      title: "Avantages",
      purpose: "Les filles d'attente ont un impact négatif sur l'expérience et la satisfaction client.",
      hero: {
        headline: "Plus de ventes, moins de stress.",
        sub: "**Équilibrez** l'affluence, **Fluidifiez** le flux client, **Fidélisez** et **Attirez** des nouveaux clients",
        ctaPrimary: "Essayez gratuitement",
        ctaSecondary: "Réserver une démo"
      },
      benefits: [
        {
          category: "Revenus",
          items: [
            "**Plus de revenus** : vous servez plus de clients et récupérez des ventes qui vous échappaient auparavant.",
            "**Moins d'abandon et plus de conversion** : les files visibles et non gérées font fuir les clients, l'attente virtuelle est mieux acceptée.",
            "**Fidélisation** : un client satisfait revient et fait croître les ventes. Les files d'attente mal gérées la sapent",
            "**Moins de no-show** : vos clients peuvent vous prévenir facilement. Si cela arrive, vous appelez le suivant aussitôt et minimisez l'impact.",
            "**Flux client fluidifié** : service plus fluide avec gestion des pics et priorisation. Salle d'attente vide avec moins d'attente par client.",
            "**Avantage concurrentiel durable** : meilleur service"
          ]
        },
        {
          category: "Productivité accrue",
          items: [
            "**Meilleure gestion de l'affluence** : information mise à jour en temps réel",
            "**Maximiser l'utilisation des ressources** : allocation dynamique des ressources efficacement",
            "**Fréquentation mieux répartie** : vos clients vérifient l'attente et peuvent décider de reporter leur arrivée.",
            "**Moins de temps vides** : vos clients se répartissent de façon homogène sur toute la durée. En absence de clients, vous pouvez vous libérer en attendant le prochain client.",
            "**Réduction des goulets d'étranglement** : permet de replanifier et s'adapter",
            "**Réduction des coûts opérationnels** : moins de tri manuel, moins de temps sans activité et moins d'espace nécessaire",
            "**Optimisation des espaces physiques** : réduction de la saturation en salle d'attente"
          ]
        },
        {
          category: "Meilleure Expérience Client",
          items: [
            "**Amélioration du service** : priorité donnée au client en cours",
            "**Équipe plus sereine** : queues organisées, interactions clients plus positives. Moins de stress à cause d'une queue qui s'allonge.",
            "**Prestige de marque** : vos clients apprécieront que leur temps soit valorisé",
            "**Rester connecté à vos clients** : vous obtenez leurs coordonnées (sous leur accord)"
          ]
        }
      ],
      steps: [
        "Le client est informé sur son téléphone du temps d'attente estimé et joint la queue quand ça lui convient le mieux.",
        "Le client suit l'avancement de la queue et reçoit des notifications quand son tour approche.",
        "Le client est informé d'où il doit se rendre quand c'est son tour.",
      ],
      useCases: [
        "Retail (retraits, service, retours, SAV) avec une file par service.",
        "Coiffeurs et Salons de beauté: pas besoin de rendez-vous à une heure fixe",
        "Santé (consultations) avec moins de congestion et appels \"juste à temps\"."
      ],
      proof: [
        "Les informations de file montrent l'attente par service et permettent d'optimiser le service.",
        "L'attente virtuelle réduit l'insatisfaction et améliore la fidélisation client.",
        "40% moins d'abandons. Les clients restent quand ils peuvent gérer les temps d'attente."
      ],
      objections: [
        { claim: "Une queue traditionnelle suffit.", reply: "smartQ estime le temps d'attente et notifie proactivement. Meilleure gestion et moins de stress." },
        { claim: "Notre demande est imprévisible.", reply: "La queue virtuelle vous permet d'anticiper le nombre de personnes prévues pour vous permettre de mieux vous organiser" },
        { claim: "Les gens ne veulent pas partager leurs coordonnées.", reply: "Ils ne sont pas obligés de remplir leur informations" }
      ],
      compliance: [
        "Transparence sur usage des données, consentement pour SMS/e-mail et alternative ticket papier pour accessibilité et équité. Publier règles de priorité si existent."
      ],
      implementation: [
        "Temps de mise en place : rapide. Rôles : propriétaire/manager + front-desk. Intégrations : canaux SMS/e-mail/push. Formation : minutes avec panel intuitif (web/mobile)."
      ],
      internalLinks: ["journey", "features", "pricing"],
      visuals: [
        "Graphique \"avant/après\" d'abandon de file.",
        "Heatmap des heures de pointe + diagramme \"file physique vs Virtual queue\"."
      ],
      seo: { meta: "Avantages de la Virtual queue : moins d'abandon, meilleure expérience et décisions avec données — simple à implémenter." }
    },

    journey: {
      title: "Expérience client",
      purpose: "Suivi du parcours client",
      hero: {
        headline: "Prenez un ticket… puis prenez votre temps.",
        sub: "La solution à l’**impatience**, aux **imprévus** et aux **abandons**",
        ctaPrimary: "Démarrer l'essai gratuit"
      },
      benefits: [
        "**Expérience mémorable** : Crée une relation positive et marquante à chaque visite grâce à un parcours simple, fluide et sans frictions.",
        "**Anticipation** : vérifie le temps d'attente avant de prendre son ticket et choisit les heures creuses. Attente choisie au lieu de subie.",
        "**Simplicité** : Scan du QR code pour rejoindre la queue en 5 secondes",
        "**Meilleure gestion du flux de clients** : gestion proactive ordonnée et contrôlée des files d'attente client",
        "**Temps d'attente réduit** : perception d'un temps d'attente réduit.",
        "**Communication fluide des délais** : un client averti est plus tolérant",
        "**Respect de son temps** : Montre que l'enseigne valorise le temps de ses clients.",
        "**Optimisation** : leur permettre d'utiliser leur temps de manière productive. où et comme ils le souhaitent",
        "**Confort** : elímine la pénibilité de l'attente, une attente plus agréable pour les clients.",
        "**Sérénite** : moins d'incertitude sur le temps d'attente.",
        "**Priorisation** : possibilité de prioriser clients avec des besoins particuliers ou en situation d'urgence",
        "**Fléxibilité** : possibilité de reporter ou annuler si leur tour n'est pas proche d'arriver"
      ],
      steps: [
        "Obtenir sa position.",
        "Suivre la progression de la queue en temps réel.",
        "Attendre d'être notifié quand son tour approche"
      ],
      useCases: [
        "Coiffeurs, salons de beauté, santé, véterinaires, guichets, SAV."
      ],
      proof: [
        "Parcours scan-pour-rejoindre illustré étape par étape.",
        "[Statistique nécessaire :  Attente perçue ↓ de X% ; walk‑outs ↓ de Y%. ]"
      ],
      objections: [
        { claim: "Quelle est la difficulté d'utilisation de pour nos clients ?", reply: "C'est très simple et accessible à tous.\n\nVos clients scannent un QR code pour se placer immédiatement dans la file d'attente ." },
        { claim: "Qu'en est-il si des clients n'en veulent pas ?", reply: "S'ils préfèrent ne pas suivre depuis leur téléphone, vous pouvez tout simplément leur indiquer leur position voire l'écrire ou l'imprimer." },
        { claim: "Mais vont-ils revenir?", reply: "Ils attendent sur place ou vous pouvez leur permettre de patienter ailleurs.\n\nNotifications et compte à rebours les maintiennent informés et engagés pour revenir à temps." }
      ],
      compliance: [
        "Texte lisible (grosse taille, contraste), alternative non‑digitale disponible."
      ],
      implementation: [
        "Imprimer le QR et l'afficher ; écran sur site optionnel pour montrer  à qui le tour ."
      ],
      internalLinks: ["features", "implementation"],
      visuals: [
        "Storyboard : Scan → Ticket multi-canal → Mises à jour → Service.",
        "Schéma file physique vs file virtuelle."
      ],
      seo: { meta: "File d'attente virtuelle : scan, suivi live, arrivée juste‑à‑temps — Attendre sans faire la queue." }
    },

    implementation: {
      title: "Implémentation & Support",
      purpose: "Rassurer : déploiement simple avec les écrans dont vous disposez et un support réactif.",
      hero: {
        headline: "Lancez-vous maintenant, vous avez tout ce qu'il faut.",
        sub: "**Prêt à démarrer · Il vous suffit votre téléphone, tablette ou ordinateur · Facile dès la première utilisation.**",
        ctaPrimary: "Essayez gratuitement",
        ctaSecondary: "Réserver une démo"
      },
      benefits: [
        "Besoin d'un téléphone, tablette ou ordinateur",
        "Configuration simple : interface intuitive",
        "Documentation : explications pas à pas",
        "Support : vous pouvez demander de l'assistance si nécessaire",
        "Affichage (facultatif) sur tv, tablette, ordinateur ou téléphone."
      ],
      steps: [
        "Nous vous donnons accès au système.",
        "Vous modifiez la configuration de la queue par défaut.",
        "Vous ajoutez votre branding"
      ],
      useCases: [
        "Avec tablette et téléphone portable.  Vous appelez la personne suivante sur votre téléphone et le numéro appelé s'affiche sur la tablette.",
        "Avec téléphone, ordinateur et écran tv.  Appel suivant depuis le téléphone, affichage des  queues sur un écran télé, administration depuis l'ordinateur."
      ],
      proof: [
        "Processus droit au but + support fiable durant la transition.",
        "[Stat needed : \"Mise en service moyenne : X h ; formation : Y min.\"]"
      ],
      objections: [
        { claim: "Est-ce difficile de mettre en place ?", reply: "La plateforme met à disposition une queue déjà prête configurée par défaut. Vous n'aurez qu'à l'éditer avec votre configuration." },
        { claim: "On n'est pas technique.", reply: "Administration et configuration intuitive. Documentation et support à disposition." },
        { claim: "Et si j'ai des difficultés?", reply: "Support disponible par mail et téléphone." },
        { claim: "Quel est le matériel indispensable ?", reply: "Vous avez juste besoin d'un téléphone (ou une tablette ou un ordinateur)." }
      ],
      compliance: [
        "Former à la protection des données, afficher une notice de confidentialité, offrir l'opt-out pour notifications."
      ],
      implementation: [
        "Temps de mise en place : [à confirmer :  Go live en 24 h ].",
        "Rôles : gérant + front-desk.",
        "Intégrations : canaux SMS/e-mail/push [fournisseur SMS à confirmer]."
      ],
      internalLinks: ["features", "faqs"],
      visuals: [
        "Checklist  Lancer en 1 jour , photo comptoir + QR + tablette."
      ],
      seo: { meta: "Implémentez vite avec vos écrans existants. Support réactif. Virtual queue sans friction." }
    },

    faqs: {
      title: "FAQs & Objections",
      purpose: "Répondre clairement aux questions des dirigeants, responsables d'exploitation et équipes d'accueil.",
      hero: {
        headline: "Des réponses et du support pour une adoption sereine.",
        sub: "QR, SMS, essai gratuit, personnalisation à votre marque : tout est là.",
        ctaPrimary: "Essayez gratuitement",
        ctaSecondary: "Réserver une démo"
      },
      benefits: [
        "Rejoindre sur site ou à distance (smartphone, site, kiosque).",
        "Aucune appli requise ; ticket papier possible.",
        "Aucun engagement de durée : abonnement mensuel, résiliable à tout moment."
      ],
      steps: [
        "Le client scanne un QR / ouvre un lien ou reçoit un ticket.",
        "Il suit sa position et son attente.",
        "Il est notifié quand son tour approche."
      ],
      useCases: [
        "Transport (réémission/ticketing), Commerce de détail (click-and-collect, retours), Santé, Services publics."
      ],
      proof: [
        "Essai gratuit 1 mois (self‑setup).",
        "Push gratuit ; SMS ≈ 0,08 € via service test Twilio pendant l'essai (compte fourni).",
        "[Stat needed :  CSAT ↑ de X% après 4 semaines. ]"
      ],
      objections: [
        { claim: "C'est quoi une file d'attente virtuelle ?", reply: "L'attente virtuelle signifie que les clients restent dans la queue sans être physiquement présents. Ils rejoignent et suivent la progression de la queue depuis leur téléphone." },
        { claim: "En quoi les files d'attente virtuelles améliorent la satisfaction des clients ?", reply: "En offrant une attente plus pratique et flexible. Les clients peuvent utiliser leur temps autrement, ce qui leur fait sentir que leur temps est respecté." },
        { claim: "En quoi les queues virtuelles sont meilleures que les queues traditionnels ?", reply: "Elles évitent l'attente physique, rendent l'attente prévisible et réduisent le stress. Elles permettent de lisser les pics de demande et améliorent l'efficacité du personnel. A final, meilleure expérience et meilleure productivité." },
        { claim: "C'est quoi smartQ?", reply: "SmartQ est un système de gestion de files d'attente virtuelles. Il permet au client de prendre un ticket numérique et de suivre la progression de la queue sur son téléphone." },
        { claim: "Est-ce indispensable de scanner un qr code ?", reply: "Non, il existe plusieurs alternatives. Par exemple, vous pouvez simplement informer de la position et suivre l'avancement comme dans une queue classique." },
        { claim: " Complexe à paramétrer ? ", reply: "Simple et intuitif, support si nécessaire." },
        { claim: " Adapté à notre taille d'entreprise ? ", reply: "De la boutique seule au réseau multi‑sites." }
      ],
      compliance: [
        "Afficher la politique de confidentialité au moment de rejoindre, consentement SMS/e‑mail, minimisation des données, droit à l'effacement."
      ],
      implementation: [
        "Self‑setup possible ; prise en main en minutes ; canaux au choix (push/e‑mail/SMS) ; pas de frais de résiliation."
      ],
      internalLinks: ["pricing", "implementation"],
      visuals: [
        "Cartes FAQ + icônes  Rejoindre la file  (QR, lien, kiosque, papier)."
      ],
      seo: { meta: "Questions sur la Virtual queue ? QR, canaux, essai, contrat : tout est clarifié — aucun engagement de durée." }
    },

    pricing: {
      title: "Tarifs",
      purpose: "Rendre la valeur évidente : essai gratuit, mise en route instantanée, aucun engagement de durée.",
      hero: {
        headline: "Transformez l’attente en avantage concurrentiel.",
        sub: "**La file d’attente qui rapporte. Essai gratuit, sans engagement.**",
        ctaPrimary: "Essayez gratuitement",
        ctaSecondary: "Réserver une démo"
      },
      benefits: [
        "**Mise en place simple et rapide** : prise en main rapide et démarrage immédiat.",
        "**Adoption simple** : interface intuitive pour une utilisation quotidienne facile.",
        "**Pilotage facile** : panneau de configuration intuitif. Pas besoin de connaissances techniques.",
        "**Paramétrable** : activation ou désactivation des fonctionnalités selon vos besoins.",
        "**Pas de matériel requis** : vous pouvez démarrer avec vos appareils existants.",
        "**Branding** : personnalisable à votre marque pour une intégration parfaite.",
        "**Essai gratuit** : essayez sans compromis pendant 30 jours.",
        "**Aucun engagement de durée** : abonnement mensuel résiliable à tout moment.",
        "**Prix abordable**.",
        "**Support client** : assistance pour vous accompagner."
      ],
      steps: [
        "Choisir un plan et lancer l'essai.",
        "Nous vous donnons accès à la plateforme.",
        "Vous configurez votre queue et vous passez en live avec votre branding"
      ],
      proof: [
        "Solo Site — 19,99 € / 14,99 £ par mois. Inclut Unlimited Walk‑ins, Statistiques de File, Générateur QR, Intégration WhatsApp, Staff Illimité, Support Business.",
        "Multi‑Site — sur demande.",
        "Custom App — sur demande (pour chaînes / grands comptes).",
        "FAQ : option self‑setup à 10 € / mois et SMS ≈ 0,08 € via Twilio en test durant l'essai — à aligner avec l'offre finale."
      ],
      objections: [
        { claim: "Y a-t-il un essai gratuit ?", reply: "Si vous effectuez la configuration par vous-même, nous vous offrons un essai gratuit d'un mois, aucun engagement de durée. Si vous prenez la formule \"Solo Site\", nous le configurons pour vous." },
        { claim: "J'ai des besoins spécifiques", reply: "Les fonctionnalités peuvent être activées depuis le panel d'administration. En cas de besoins particuliers, contactez-nous." },
        { claim: "Quelle est la durée du contrat?", reply: "Facturation mensuelle, annulation à tout moment pour une flexibilité maximale." },
        { claim: "Et le coût par SMS ?", reply: "Notifications push gratuites (Android), SMS via fournisseur (ex. Twilio) à ses tarifs." }
      ],
      compliance: [
        "Transparence sur les coûts tiers (SMS), conditions de résiliation et protection des données."
      ],
      implementation: [
        "Essai gratuit, setup instantané, annulation à tout moment."
      ],
      internalLinks: ["features", "faqs"],
      visuals: [
        "Cartes plans côte‑à‑côte + note coûts SMS."
      ],
      seo: { meta: "Tarifs clairs pour la Virtual queue : essai gratuit, aucun engagement de durée, setup instantané — du Solo au Custom." }
    },

    "use-cases": {
      title: "Secteurs & cas d'usage",
      purpose: "Montrer où smartQ crée de la valeur au quotidien, du retail à la santé en passant par le public.",
      hero: {
        headline: "Là où il y a la queue, smartQ vous fait avancer.",
        sub: "Adapté à des entreprises de toutes les tailles et secteurs, améliorez efficience, conversion et l'expérience client.",
        ctaPrimary: "Essayez gratuitement",
        ctaSecondary: "Réserver une démo"
      },
      benefits: [
        "Retail & click‑and‑collect : retraits fluides, retours organisés.",
        "Santé : salles d'attente moins chargées, patients rassurés.",
        "Services publics : ordre premier arrivé, premier servi transparent.",
        "Transport : réémissions et guichets sous contrôle."
      ],
      steps: [
        "Publiez le QR/lien sur site et en ligne.",
        "Les clients rejoignent ; l'équipe suit la demande en temps réel.",
        "Service dans l'ordre et notification du suivant."
      ],
      useCases: [
        "Comptoirs service/retours",
        "Santé",
        "Retail Selling",
        "Salons et Coiffeurs"
      ],
      proof: [
        "Polyvalent pour tout business gérant une file.",
        "[Stat needed : \"Débit (clients/h) ↑ de X% ; temps mort ↓ de Y%.\"]"
      ],
      objections: [
        { claim: " Notre contexte est unique. ", reply: "smartQ est hautement personnalisable (nom, logo, textes, langues)." },
        { claim: " Nous avons trop de services différents. ", reply: "Segmentez par file/service." },
        { claim: "Quels secteurs ?", reply: "Transport, retail, santé, services publics - partout où il y a des files d'attente." }
      ],
      compliance: [
        "Accessibilité (écrans lisibles, langues), publication des règles d'équité."
      ],
      implementation: [
        "Monosite ou multi‑sites : même simplicité, écran sur site optionnel."
      ],
      internalLinks: ["features", "pricing"],
      visuals: [
        "Tuiles secteurs (Retail, Santé, Public, Transport).",
        "Diagramme segmentation des files."
      ],
      seo: { meta: "Virtual queue pour Retail, Santé, Public, Transport : Simple and Easy Queue Management System adaptable." }
    }
  },
  checklist: [],
  openQuestions: []
}

// Navigation items for French
export const navigationFr = {
  main: [
    { name: 'Bénéfices', href: '/benefits' },
    { name: 'Fonctionnalités', href: '/features' },
    { name: 'Utilisation', href: '/journey' },
    { name: 'Implémentation', href: '/implementation' },
    { name: 'Prix', href: '/pricing' },
    { name: 'FAQ', href: '/faqs' },
  ],
  cta: [
    { name: 'Essai gratuit', href: '/fr/signup', primary: true },
    { name: 'Réserver une démo', href: 'https://calendly.com/contact-smartq', primary: false },
  ],
  footer: [
    { name: 'Confidentialité', href: '/privacy' },
    { name: 'Conditions', href: '/terms' },
    { name: 'Contact', href: 'mailto:contact@smartq.prod' },
  ]
}

// French site configuration
export const siteConfigFr = {
  name: 'smartQ',
  description: 'Système de Gestion de Queue Virtuel.<br>La meilleure façon d\'attendre.',
  url: 'https://smartq.pro',
  ogImage: 'https://smartq.pro/social/og.jpg',
  links: {
    twitter: 'https://twitter.com/smartqueue',
    github: 'https://github.com/smartqueue',
  },
}

// French footer sections
export const footerSectionsFr = {
  product: 'Produit',
  company: 'Entreprise',
  legal: 'Légal'
}

// Helper function to process markdown-like bold text and line breaks
export function processMarkdownFr(text: string): string {
  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br>');
}
